module.exports = __webpack_public_path__ + "img/1-min (13).798551b6.png";